// External Dependencies
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Internal Dependencies
import PhotosComponent from '../photos/photos';
import apiService from '../../services.js/apiService';
import { getPage, updatePage } from '../../actions/admin/pageAction';
import { ImageType } from '../../common/constants';

const Photos = (props) => {
  const getMediaFromEntity = (page) => page.images || [];

  return (
    <PhotosComponent
      {...props}
      fetchEntity={props.getPage}
      uploadMedia={apiService.uploadPageImage}
      deleteMedia={(pageId, imageData) => apiService.deletePageImage(pageId, { imageData, imageType: ImageType.Photo })}
      updateEntity={props.updatePage}
      getMediaFromEntity={getMediaFromEntity}
      mediaFieldName="images"
      title="Cover Image"
    />
  );
};

const mapDispatchToProps = {
  getPage,
  updatePage,
};

Photos.propTypes = {
  getPage:    PropTypes.func.isRequired,
  updatePage: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(Photos);
